
import { xyz_n_1of4 } from './SL00000Sprint00TTR'

import { list49200Sprint05 } from '../ActivityLists/AL49200Sprint05'
import { list49200Sprint06 } from '../ActivityLists/AL49200Sprint06'

import { sprintPlanningExpectations } from './SL44000Sprint06TTR'

// Software Systems Capstone (SSC) sprint 6 global values.
const sprint = 6
const activityList = () => { return list49200Sprint06(sprint) }
const activityListPrevious = () => { return list49200Sprint05(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ssc_6_1of4 = () => { return xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations) }

export const ssc_6_slidedeckTTR = [ ssc_6_1of4, null, null, null ]